var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSongDetail = function SvgSongDetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.919 1.297h3.405a.649.649 0 1 0 0-1.297H2.92A2.92 2.92 0 0 0 0 2.919v3.405a.649.649 0 1 0 1.297 0V2.92c0-.896.726-1.622 1.622-1.622M17.676 0a.649.649 0 1 0 0 1.297h3.405c.896 0 1.622.726 1.622 1.622v3.405a.649.649 0 1 0 1.297 0V2.92A2.92 2.92 0 0 0 21.081 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.896 5.676c.358 0 .648.29.648.648v8.597c0 1.316-.88 2.469-2.149 2.816l-.843.23a2.405 2.405 0 1 1-1.267-4.64l2.962-.807V6.324c0-.358.29-.648.649-.648m-.649 8.188-2.62.715a1.107 1.107 0 1 0 .583 2.137l.843-.23a1.62 1.62 0 0 0 1.194-1.565z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 17.676a.649.649 0 1 0-1.297 0v3.405c0 .896-.726 1.622-1.622 1.622h-3.405a.649.649 0 1 0 0 1.297h3.405A2.92 2.92 0 0 0 24 21.081zM.649 17.027c.358 0 .648.29.648.649v3.405c0 .896.726 1.622 1.622 1.622h3.405a.649.649 0 1 1 0 1.297H2.92A2.92 2.92 0 0 1 0 21.081v-3.405c0-.359.29-.649.649-.649"
  })));
};
export default SvgSongDetail;